import { Row, SPINNER_SIZE, Spinner } from "@ndlib/component-library"

export const LoadingRow = () => {
  return (
    <Row sx={{width: '100%', padding: 6}} justify='center'>
      <Spinner size={SPINNER_SIZE.LG} />
    </Row>
  )
}